type ConsultationActionOptions = {
  canWriteAppointment: boolean;
  canCreateEncounter: boolean;
  canCheckIn: boolean;
  hasLinkedEncounter: boolean;
  canUseFullAppointmentActions: boolean;
  isSuperuser?: boolean;
};

export function canStartConsultationAction({
  canWriteAppointment,
  canCreateEncounter,
  canCheckIn,
  hasLinkedEncounter,
  canUseFullAppointmentActions,
  isSuperuser,
}: ConsultationActionOptions) {
  return (
    canWriteAppointment &&
    (isSuperuser || canCheckIn) &&
    (hasLinkedEncounter || (canUseFullAppointmentActions && canCreateEncounter))
  );
}

type AppointmentActionCapabilityOptions = {
  isPractitionerWorkspace: boolean;
  canAccessNursingActions: boolean;
  isSuperuser?: boolean;
};

export function canUseFullAppointmentActions({
  isPractitionerWorkspace,
  canAccessNursingActions,
  isSuperuser,
}: AppointmentActionCapabilityOptions) {
  return Boolean(
    isSuperuser || !isPractitionerWorkspace || canAccessNursingActions,
  );
}
